import React from 'react';
import styled from 'styled-components/native';
import Icon from 'react-native-vector-icons/dist/Feather';
import { translate } from '../utils/translate';

const FallbackContainer = styled.View`
    padding: 30px;
    align-items: center;
    justify-content: center;
    background-color: #f9f9f9;
    border-radius: 8px;
    margin: 15px 0;
    min-height: 100px;
`;

const FallbackText = styled.Text`
    font-family: "OpenSans";
    font-size: 14px;
    color: #666;
    margin-top: 10px;
`;

const ReloadButton = styled.Text`
    font-family: "OpenSansSemiBold";
    font-size: 13px;
    color: #11025d;
    margin-top: 12px;
    cursor: pointer;
    padding: 8px 16px;
    border: 1px solid #11025d;
    border-radius: 6px;
`;

function DefaultFallback({ isFullPage }) {
    return (
        <FallbackContainer style={isFullPage ? { minHeight: '100vh', backgroundColor: '#f1f1f1' } : {}}>
            <Icon name="alert-circle" size={isFullPage ? 32 : 22} color="#999" />
            <FallbackText>{translate(isFullPage ? 'error.server_title' : 'error.section_failed')}</FallbackText>
            {isFullPage && (
                <ReloadButton onClick={() => window.location.reload()}>
                    {translate('error.reload')}
                </ReloadButton>
            )}
        </FallbackContainer>
    );
}

export default class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error('ErrorBoundary caught:', error, errorInfo);
    }

    componentDidUpdate(prevProps) {
        if (this.state.hasError && prevProps.children !== this.props.children) {
            this.setState({ hasError: false });
        }
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }
            return <DefaultFallback isFullPage={this.props.fullPage} />;
        }
        return this.props.children;
    }
}
